/* eslint-disable react/no-unknown-property */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/alt-text */
import { useTranslation } from 'react-i18next';
import RowLayout from '@components/RowLayout';
import { Box, Stack, Typography } from '@mui/material';

import { useEffect, useState } from 'react';
import MySelect from '@components/MySelect/new';
import { useLocation } from 'react-router-dom';
import PolicyTable from '@components/PolicyTable';
import {
  marketing,
  marketingDateOptions,
  policy,
  terms,
  cctv,
  termsAndPolicyDateOptions,
  cctvDateOptions
} from './enhance';

const dataMap = {
  terms,
  'privacy-policy': policy,
  'cctv-management-policy': cctv,
  'marketing-consent': marketing
};

// 시행일(effectiveDate, KST 자정 기준)이 도래하지 않은 버전은 노출하지 않는다
const isEffective = (option) =>
  !option.effectiveDate ||
  new Date() >= new Date(`${option.effectiveDate}T00:00:00+09:00`);

const getDateOptions = (type) => {
  if (type === 'marketing-consent') {
    return marketingDateOptions;
  }
  if (type === 'cctv-management-policy') {
    return cctvDateOptions;
  }

  return termsAndPolicyDateOptions;
};

const getDefaultIndex = (type) => {
  const options = getDateOptions(type).filter(isEffective);
  return options[options.length - 1].value;
};

export default function TermsAndPolicyPage() {
  const { t } = useTranslation(null, { keyPrefix: 'button' });
  const { pathname } = useLocation();
  const pathArr = pathname.split('/');
  const type = pathArr[pathArr.length - 1];

  const [termDate, setTermDate] = useState(() => getDefaultIndex(type));
  const [currentItem, setCurrentItem] = useState({});

  const targetDateOptions = () => getDateOptions(type).filter(isEffective);

  useEffect(() => {
    const data = dataMap[type] || terms;
    setCurrentItem(data[termDate]);
  }, [termDate, type]);

  return (
    <RowLayout
      sx={{
        width: '100%',
        height: 'auto',
        backgroundColor: { xs: '#FFFFFF' },
        alignItems: 'center',
        py: { md: '140px', xs: '40px' }
      }}
    >
      <Stack
        sx={{
          width: { md: '100%', lg: '100%' },
          height: '100%',
          maxWidth: { xs: '100%', lg: '1920px' },
          px: { xs: '0px', sm: '20px', md: '40px', lg: '320px' },
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'flex-start'
        }}
      >
        <Stack
          sx={{
            color: 'text.primary',
            py: 0,
            px: 0,
            mt: '28px',
            mb: '28px'
          }}
        >
          <Typography
            sx={{
              fontSize: { xs: 24, md: 48 },
              textAlign: 'center',
              fontWeight: 700,
              wordBreak: 'keep-all',
              letterSpacing: '-2.4px',
              color: '#212121'
            }}
          >
            {currentItem?.title}
          </Typography>
        </Stack>
        {/* content */}
        <Stack
          sx={{
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            justifyContent: 'flex-start',
            overflow: 'hidden',
            py: 3.5,
            pl: 2,
            pr: 2
          }}
        >
          {/* header */}
          <Stack
            sx={{
              width: '100%',
              height: 'auto',
              gap: 4.5,
              overflowY: 'hidden'
            }}
          >
            {currentItem?.items?.map((i, index) => {
              return (
                <Stack key={index} sx={{ width: '100%', gap: 1.5 }}>
                  <Typography
                    sx={{
                      fontSize: 18,
                      letterSpacing: '-0.54px',
                      fontWeight: 500,
                      color: '#212121',
                      ...(type === 'marketing-consent' &&
                        index === 0 && {
                          color: '#919193',
                          fontSize: 14,
                          letterSpacin: '-0.42px'
                        })
                    }}
                  >
                    {i?.title}
                  </Typography>

                  {/* paragraphs */}
                  <Stack sx={{ gap: 1.5 }}>
                    {i?.paragraphs?.map((paragraph, index) => (
                      <Stack sx={{ gap: 1 }} key={index}>
                        {paragraph?.title && (
                          <Typography
                            key={index}
                            sx={{
                              color: '#919193',
                              fontSize: 14,
                              letterSpacing: '-0.42px',
                              whiteSpace: 'pre-line',
                              wordBreak: 'keep-all', // Prevent breaking words
                              overflowWrap: 'break-word' // Handle l
                            }}
                          >
                            {!paragraph?.noIndex && `${index + 1}.  `}{' '}
                            {paragraph?.title}
                          </Typography>
                        )}
                        <Stack
                          sx={{
                            gap: 0.5,
                            alignItems: 'flex-start',
                            justifyContent: 'flex-start'
                          }}
                        >
                          {paragraph?.body?.map((bodyItem, bIndex) => {
                            const content =
                              bodyItem?.type === 'image' ? (
                                <div
                                  key={bIndex}
                                  style={{
                                    width: '100%',
                                    display: 'flex',
                                    justifyContent: 'center'
                                  }}
                                >
                                  <Box
                                    component="img"
                                    src={bodyItem?.value}
                                    alt="policy"
                                    style={{
                                      maxHeight: '250px',
                                      maxWidth: { xs: '100%', md: '75%' },
                                      objectFit: 'contain'
                                    }}
                                  />
                                </div>
                              ) : (
                                <Typography
                                  key={bIndex}
                                  sx={{
                                    ml: bodyItem?.isChild ? 2.5 : 1,
                                    color: '#919193',
                                    fontSize: { xs: 13, md: 14 },
                                    letterSpacing: '-0.42px',
                                    whiteSpace: 'pre-line',
                                    wordBreak: 'keep-all',
                                    overflowWrap: 'break-word'
                                  }}
                                >
                                  {bodyItem?.value}
                                </Typography>
                              );
                            if (bodyItem?.type === 'policy-table')
                              return <PolicyTable />;
                            if (bodyItem?.type === 'html') {
                              return bodyItem.html;
                            }
                            return content;
                          })}
                        </Stack>
                      </Stack>
                    ))}
                  </Stack>
                </Stack>
              );
            })}
          </Stack>
          <Stack
            sx={{
              width: '100%',
              alignItems: 'center',
              mt: 2,
              flexDirection: 'row',
              justifyContent: 'flex-end'
            }}
          >
            <Typography
              sx={{ fontSize: 15, fontWeight: 600, color: '#515255', mr: 1 }}
            >
              시행일자
            </Typography>
            <MySelect
              data={targetDateOptions()}
              value={termDate}
              onChange={(e) => setTermDate(e?.target?.value)}
              sx={{}}
            />
          </Stack>
        </Stack>
      </Stack>
    </RowLayout>
  );
}
